'use strict';

angular.module('ClinicApp').controller('ModalErrorMessage', function($scope, $modalInstance, errorText) {
  $scope.errorText = errorText;

  $scope.close = function() {
    $modalInstance.dismiss();
  };
});
